import React from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonProps,
  ColorTokens,
  useColorTokens
} from "@tvg/design-system";
import ActiveBetsButton from "../../ActiveBetsButton";
import { BetContainer, Container, InfoContainer } from "./styled-components";
import { RaceWagerSummary } from "../../../../types";
import { getTrackHeaderEnhacement } from "../../../../store/selectors";

interface AuxiliaryModulesButtonsProps {
  hasWagers?: boolean;
  raceWagersSummary: RaceWagerSummary;
  onClickPoolsInfo: () => void;
  onClickBetsButton?: () => void;
}

const AuxiliaryModulesButtons = ({
  hasWagers,
  raceWagersSummary,
  onClickPoolsInfo,
  onClickBetsButton
}: AuxiliaryModulesButtonsProps) => {
  const colorTokens = useColorTokens() as ColorTokens;
  const hasTrackHeaderEnhacement = useSelector(getTrackHeaderEnhacement);

  const computInfoButonProps = () => {
    const props: Partial<ButtonProps> = {};
    if (hasTrackHeaderEnhacement) {
      props.border = `solid 1px ${colorTokens.component.button.tertiary.border.base}`;
      props.borderRadius = 4;
      props.isStretched = true;
    }

    return props;
  };

  const renderInfoButton = () => (
    <Button
      qaLabel="pools-and-info-button"
      variant="tertiary"
      onPress={onClickPoolsInfo}
      icon="info"
      iconPosition="start"
      size="m"
      {...computInfoButonProps()}
    >
      Pools & Info
    </Button>
  );

  const renderBetsButton = () =>
    hasWagers &&
    onClickBetsButton && (
      <ActiveBetsButton
        iconPosition="start"
        totalGambledCount={raceWagersSummary.totalGambledCount}
        onClick={onClickBetsButton}
      />
    );

  if (!hasTrackHeaderEnhacement) {
    return (
      <Container data-qa-label="auxiliary-buttons-container">
        {renderInfoButton()}
        {renderBetsButton()}
      </Container>
    );
  }

  return (
    <>
      <InfoContainer data-qa-label="auxiliary-buttons-container">
        {renderInfoButton()}
      </InfoContainer>
      <BetContainer>{renderBetsButton()}</BetContainer>
    </>
  );
};

export default AuxiliaryModulesButtons;
